<template>
  <ResetrPasswordComp></ResetrPasswordComp>
</template>
<script>
import ResetrPasswordComp from "../../components/Auths/ResetPassword.vue";

export default {
  name: "Not Found",
  components: { ResetrPasswordComp },
  computed: {},
  mounted() {},
};
</script>
